// extracted by mini-css-extract-plugin
export default {"NewBadgeLabel":"NewBadgeLabel_NewBadgeLabel__AkuNw","NewBadgeLabel__Text":"NewBadgeLabel_NewBadgeLabel__Text__+vylJ"};